import Repository from './Repository';

const resource = '/teams';

export default {
    get(payload)         {return Repository.get(`${resource}`, payload);},
    settings(id)         {return Repository.get(`${resource}/${id}/settings`);},
    permissions(payload) {return Repository.put(`${resource}/permissions`, payload);},
    storeAttachment(payload) {return Repository.post(`${resource}/attachments`, payload);},
}